/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Role_ViewerInputs */



/**
* | output |
* | --- |
* | "Viewer" |
*
* @param {Team_Manager_Role_ViewerInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_role_viewer = /** @type {((inputs?: Team_Manager_Role_ViewerInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Role_ViewerInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Lecteur")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zuschauer")
	if (locale === "it") return /** @type {LocalizedString} */ ("Spettatore")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Зритель")
	if (locale === "es") return /** @type {LocalizedString} */ ("Espectador")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("观众")
	if (locale === "ja") return /** @type {LocalizedString} */ ("視聴者")
	if (locale === "hi") return /** @type {LocalizedString} */ ("दर्शक")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Visualizador")
	return /** @type {LocalizedString} */ ("Viewer")
});